export default __webpack_public_path__ + "static/headortails-724814386b385741cbd660996d9169c7.png";